import { createSlice } from "@reduxjs/toolkit";

export const topCustomersSlice = createSlice({
  name: "top_customers",
  initialState: {
    topCustomers: "",
    errors: [],
  },

  reducers: {
    getTopCustomers: (state, action) => {
      state.topCustomers = action.payload;
    },
    getTopCustomersList: (state, action) => {
      state.topCustomers = action.payload;
    },
    getErrors: (state, action) => {
      state.errors = action.payload;
    },
  },
});
export const { getTopCustomers, getTopCustomersList, getErrors } =
  topCustomersSlice.actions;

export default topCustomersSlice.reducer;
